import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { showApiErrorToast } from '@/utils/errors';
import { createInstituteType, instituteTypeQueryKeys } from '../api/instituteTypes.api';
import type { CreateInstituteTypePayload } from '../types/instituteType.types';

export function useCreateInstituteType(onSuccess?: () => void) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: CreateInstituteTypePayload) => createInstituteType(payload),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: instituteTypeQueryKeys.all() });
      toast.success('Institute type created successfully');
      onSuccess?.();
    },
    onError: (error) => {
      showApiErrorToast(error, 'Failed to create institute type');
    },
  });
}
